import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

import { resultsContainer as styles } from '../styles';

const TextSquare = props => {
  const { title, classes, value, className = '' } = props;
  return (
    <div className={classNames(classes.squareTextState, className)}>
      {title ? <div>{title}</div> : ''}
      {value ? <div>{value}</div> : ''}
    </div>
  );
};

TextSquare.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(TextSquare);
